import { useQuery } from '@tanstack/react-query';

import { useFDMServices } from '../../../providers/fdm-services/fdm-services.context';
import { QueryKeys } from '../../../utils/queryKeys';
import type { ModelAndRevision3D } from '../types';

export const useRevision = (modelId: number, revisionId: number) => {
  const { threeDService } = useFDMServices();

  const { data, isLoading, error } = useQuery<ModelAndRevision3D, Error>({
    queryKey: [QueryKeys.THREE_D, 'revision', modelId, revisionId],
    queryFn: async () => {
      return await threeDService.getRevisionById(modelId, revisionId);
    },
    meta: { error: { captureError: true } },
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    enabled: Boolean(modelId && revisionId),
  });

  return { data, isLoading, error };
};
